// DashboardAdmin.js - com desbloqueio de som garantido via botão e clique
import React, { useEffect, useState, useRef } from 'react';
import SidebarYou from './SidebarYou';
import TopBarYou from './TopBarYou';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import './dashboardyou.css';
import { isMobile, isTablet, isSmartTV, isBrowser } from 'react-device-detect';
import KanbanDashboard from './KanbanDashboard';

const DashboardAdmin = () => {
  const [tema] = useState(localStorage.getItem("tema") || "dark");
  const [periodoAcessos, setPeriodoAcessos] = useState('7d');
  const [periodoAnalise, setPeriodoAnalise] = useState('7d');
  const [periodoPix, setPeriodoPix] = useState('7d');
  const [periodoMetodo, setPeriodoMetodo] = useState('30d');
  const [dadosAcessos, setDadosAcessos] = useState([]);
  const [listaAcessos, setListaAcessos] = useState([]);
  const [dadosAnalise, setDadosAnalise] = useState([]);
  const [listaAnalise, setListaAnalise] = useState([]);
  const [dadosPix, setDadosPix] = useState([]);
  const [listaPix, setListaPix] = useState([]);
  const [dadosMetodo, setDadosMetodo] = useState([]);
  const [listaMetodo, setListaMetodo] = useState([]);
  const [somAtivo, setSomAtivo] = useState(false);
  const [ultimoItemDestacado, setUltimoItemDestacado] = useState({
    acessos: null,
    analises: null,
    pix: null,
    metodo: null,
  });
  const audioContextRef = useRef(null);
  const ultimoIdRefAcesso = useRef(null);
  const ultimoIdRefAnalise = useRef(null);
  const ultimoIdRefPix = useRef(null);
  const ultimoIdRefMetodo = useRef(null);
  const ultimoStatusRefMetodo = useRef(null);
  const idsConcluidosRefMetodo = useRef(new Set());
  const [novosConcluidos, setNovosConcluidos] = useState([]);
  const [mostrarAvisoSom, setMostrarAvisoSom] = useState(true); // mostra modal inicial




  const buscarDados = (url, periodo, setDados, setLista, refId) => {
    fetch(`${url}?periodo=${periodo}`, { headers: { 'X-API-Key': 'UNIVERSOYOU-123456' } })
      .then(res => res.json())
      .then(data => {
        setDados(data.grafico || []);
        setLista(data.ultimos || []);
        const ultimo = data.ultimos && data.ultimos[0];
        if (ultimo) {
          const idMap = {
            'get_acessos_leads.php': 'acessos',
            'get_leads_analise.php': 'analises',
            'get_pix_confirmado.php': 'pix',
            'get_leads_metodoyou.php': 'metodo'
          };
          const tipo = Object.entries(idMap).find(([urlPartial]) => url.includes(urlPartial))?.[1];
          const sonsPorTipo = {
            acessos: '/assets/som-acesso.mp3',
            analises: '/assets/som-analise.mp3',
            pix: '/assets/som-pix.mp3',
            metodo: '/assets/som-metodo.mp3'
          };


          let deveTocarSom = false;

          if (tipo === 'metodo') {
            const novosIds = [];

            const novosConcluidosAtualizados = new Set(idsConcluidosRefMetodo.current); // cópia atual

            (data.ultimos || []).forEach(item => {
              if (item.status === 'concluido') {
                if (!novosConcluidosAtualizados.has(item.id)) {
                  novosConcluidosAtualizados.add(item.id);  // novo concluído
                  novosIds.push(item.id);                   // para tocar som
                }
              } else {
                // Se o status não for mais "concluido", remove da lista
                if (novosConcluidosAtualizados.has(item.id)) {
                  novosConcluidosAtualizados.delete(item.id);
                }
              }
            });

            // Atualiza lista global e estado
            idsConcluidosRefMetodo.current = novosConcluidosAtualizados;
            setNovosConcluidos(Array.from(novosConcluidosAtualizados));

            // Só toca som se houve novos
            if (novosIds.length > 0 && somAtivo && audioContextRef.current) {
              const audio = new Audio(sonsPorTipo[tipo]);
              audio.play().catch(err => {
                console.warn(`🔇 Erro ao tocar som de ${tipo}:`, err);
              });
            }


            if (novosIds.length > 0) {
              if (somAtivo && audioContextRef.current) {
                deveTocarSom = true;
              }
              setNovosConcluidos(prev => [...new Set([...prev, ...novosIds])]);
            }




            const idMudou = ultimo.id !== refId.current;
            const statusMudou = ultimo.status !== ultimoStatusRefMetodo.current;

            if (idMudou || statusMudou) {
              setUltimoItemDestacado(prev => ({ ...prev, [tipo]: ultimo.id }));
              refId.current = ultimo.id;
              ultimoStatusRefMetodo.current = ultimo.status;
            }
          } else {
            const idMudou = ultimo.id !== refId.current;
            if (idMudou) {
              if (somAtivo && audioContextRef.current) {
                deveTocarSom = true;
              }
              if (tipo) {
                setUltimoItemDestacado(prev => ({ ...prev, [tipo]: ultimo.id }));
              }
              refId.current = ultimo.id;
            }
          }

          if (deveTocarSom && tipo && sonsPorTipo[tipo]) {
            try {
              const audio = new Audio(sonsPorTipo[tipo]);
              audio.play().catch(err => {
                console.warn(`🔇 Erro ao tocar som de ${tipo}:`, err);
              });
            } catch (err) {
              console.warn(`🔇 Erro inesperado ao tocar som de ${tipo}:`, err);
            }
          }


        }

      });
  };

  const atualizarTudo = () => {
    buscarDados('https://api.youevolution.com.br/get_acessos_leads.php', periodoAcessos, setDadosAcessos, setListaAcessos, ultimoIdRefAcesso);
    buscarDados('https://api.youevolution.com.br/get_leads_analise.php', periodoAnalise, setDadosAnalise, setListaAnalise, ultimoIdRefAnalise);
    buscarDados('https://api.youevolution.com.br/get_pix_confirmado.php', periodoPix, setDadosPix, setListaPix, ultimoIdRefPix);
    buscarDados('https://api.youevolution.com.br/get_leads_metodoyou.php', periodoMetodo, setDadosMetodo, setListaMetodo, ultimoIdRefMetodo);
  };

  useEffect(() => {
    atualizarTudo();
    const intervalo = setInterval(atualizarTudo, 10000);
    return () => clearInterval(intervalo);
  }, [periodoAcessos, periodoAnalise, periodoPix, periodoMetodo, somAtivo]);

  useEffect(() => {
    const base = "sidebar-mini layout-fixed layout-navbar-fixed";
    const modo = tema === "dark" ? "dark-mode" : "";
    document.body.className = `${base} ${modo}`;
    if (isMobile || isTablet) {
      const aside = document.querySelector('aside.main-sidebar');
      if (aside) aside.style.display = 'none';
    }

    const desbloquearSom = () => {
      if (!audioContextRef.current && typeof AudioContext !== "undefined") {
        audioContextRef.current = new AudioContext();
        audioContextRef.current.resume().then(() => {
          console.log("🔊 Áudio desbloqueado pelo clique");
        });
      }
    };

    document.addEventListener('click', desbloquearSom);
    return () => document.removeEventListener('click', desbloquearSom);
  }, [tema]);

  const renderFiltro = (periodo, setPeriodo) => (
    <div className="d-flex flex-wrap gap-1 justify-content-end filtro-tempo">
      {['1h', '24h', '7d', '30d', 'all'].map(p => (
        <button
          key={p}
          onClick={() => setPeriodo(p)}
          className={`btn btn-sm ${periodo === p ? 'btn-primary' : 'btn-outline-secondary'}`}
          style={{ minWidth: '40px', padding: '2px 6px', fontSize: '0.75rem' }}
        >
          {p}
        </button>
      ))}
    </div>
  );

  return (
    <>
      {mostrarAvisoSom && (
        <div className="modal-som">
          <div className="modal-box-som">
            <h2>🔊 Deseja ativar o som?</h2>
            <p>Para ouvir alertas de novos eventos, clique no botão abaixo:</p>
            <button
              onClick={() => {
                if (!audioContextRef.current && typeof AudioContext !== "undefined") {
                  audioContextRef.current = new AudioContext();
                  audioContextRef.current.resume().then(() => {
                    console.log("🔊 ÁudioContext desbloqueado via modal");
                    setSomAtivo(true);
                    setMostrarAvisoSom(false);
                  });
                }
              }}
              className="btn btn-success mt-3"
            >
              ✅ Ativar Som
            </button>
          </div>
        </div>
      )}

      <div className={`dashboard-you min-h-screen ${tema}`}>
{!(isMobile || isTablet) && (
  <TopBarYou
    titulo="Dashboard"
    somAtivo={somAtivo}
    setSomAtivo={setSomAtivo}
    audioContextRef={audioContextRef}
    setMostrarAvisoSom={setMostrarAvisoSom}
  />
)}

        {(isBrowser || isSmartTV) && <SidebarYou />}
        <div className="dashboard-content content pb-5" style={{ marginLeft: '70px', marginTop: '70px', maxWidth: '1920px' }}>
          <div className="container-fluid">

            {/* Cards dos gráficos e filtros */}
            <div className="row">
              {[{
                titulo: '📈 Acessos', dados: dadosAcessos, lista: listaAcessos, periodo: periodoAcessos, setPeriodo: setPeriodoAcessos, cor: '#60A5FA', dataKey: 'total', tipo: 'acessos'
              }, {
                titulo: '🧠 Análises', dados: dadosAnalise, lista: listaAnalise, periodo: periodoAnalise, setPeriodo: setPeriodoAnalise, cor: '#f59e0b', dataKey: 'total', tipo: 'analises'
              }, {
                titulo: '💸 Pix', dados: dadosPix, lista: listaPix, periodo: periodoPix, setPeriodo: setPeriodoPix, cor: '#10b981', dataKey: 'total', tipo: 'pix'
              }, {
                titulo: '🔍 Método YOU', dados: dadosMetodo, lista: listaMetodo, periodo: periodoMetodo, setPeriodo: setPeriodoMetodo, cor: '#f43f5e', dataKey: 'total', tipo: 'metodo'
              }].map((card, idx) => (
                <div className="col-xl-3 col-lg-6 col-md-6" key={idx}>
                  <div className="card bg-dark" style={{ height: '400px' }}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h3 className="card-title mb-0">{card.titulo}</h3>
                      {renderFiltro(card.periodo, card.setPeriodo)}
                    </div>
                    <div className="card-body p-2">
                      <ResponsiveContainer width="100%" height={220}>
                        <LineChart data={card.dados}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="hora" />
                          <YAxis allowDecimals={false} />
                          <Tooltip />
                          <Line type="monotone" dataKey={card.dataKey} stroke={card.cor} strokeWidth={2} />
                        </LineChart>
                      </ResponsiveContainer>
                      <div style={{ maxHeight: '120px', overflowY: 'auto', fontSize: '11px', marginTop: '5px' }}>
                        <ul className="text-gray-300">
                          {card.lista.map((item, i) => (
                            <li
                              key={i}
                              className={
                                novosConcluidos.includes(item.id)
                                  ? 'destacar-concluido'
                                  : ''
                              }
                            >

                              {(() => {
                                switch (card.tipo) {
                                  case 'acessos': {
                                    const token = (item.token_lead || '').replace(/^you_/, '');
                                    const ip = item.ip || '';
                                    const pagina = item.pagina || '';
                                    const afiliado = pagina.includes('/') ? pagina.split('/').pop() : '';
                                    return `${item.data_hora} - ${afiliado} - ${token.slice(-8)} - ${ip}`;
                                  }
                                  case 'analises': {
                                    const token = (item.token || '');
                                    const nome = (() => {
                                      const original = (item.nome_completo || '').trim();
                                      if (!original) return ''; // retorna string vazia se nome estiver em branco
                                      const partes = original.split(/\s+/);
                                      if (partes.length <= 2) return partes.join(' ');
                                      const primeiro = partes[0];
                                      const ultimo = partes[partes.length - 1];
                                      const meios = partes.slice(1, -1).map(p => p.charAt(0).toUpperCase()).join(' ');
                                      return `${primeiro} ${meios} ${ultimo}`;
                                    })();

                                    const email = item.email ? `(${item.email})` : '';
                                    const ip = item.ip || '';
                                    return `${item.data_hora} - ${token.slice(-8)} - ${nome} - ${ip}`;
                                  }
                                  case 'pix': {
                                    const token = (item.token || '');
                                    const status = (item.status || '');
                                    const descricao = (item.solicitacao_pagador || '').replace(/^Diagnóstico YOU\s*-\s*/i, '');
                                    const nome = (() => {
                                      const original = (descricao || '').trim();
                                      if (!original) return ''; // retorna string vazia se nome estiver em branco
                                      const partes = original.split(/\s+/);
                                      if (partes.length <= 2) return partes.join(' ');
                                      const primeiro = partes[0];
                                      const ultimo = partes[partes.length - 1];
                                      const meios = partes.slice(1, -1).map(p => p.charAt(0).toUpperCase()).join(' ');
                                      return `${primeiro} ${meios} ${ultimo}`;
                                    })();

                                    return `${item.data_hora} - ${status} -${item.txid || ''} - ${nome}`;
                                  }

                                  case 'metodo': {
                                    return `${item.data_hora} - ${item.nome || ''} - Status: ${item.status || ''} - ${(item.token || '').replace(/^you_/, '')}`;
                                  }
                                  default:
                                    return '';
                                }
                              })()}


                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Kanban */}
            <div className="row mt-4">
              <div className="col-12">
                <div className="card bg-dark p-3" style={{ maxHeight: '460px', overflowY: 'auto' }}>
                  <KanbanDashboard />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardAdmin;
